import { listReport } from './ClientDeviceByDay/ClientDevice.i18n.ja'

export const clientDevice = {
  listReport,
}
